import { useEffect, useState } from 'react';
import { api } from '../../api.ts';
import type { Named } from './types.ts';

/** Type-ahead merchant search (one country); shows the chosen merchant with a clear button. */
export function MerchantPicker({ value, onChange, market, label = 'Merchant', disabled = false }: { value: Named | null; onChange: (merchant: Named | null) => void; market?: string; label?: string; disabled?: boolean }) {
  const [q, setQ] = useState('');
  const [options, setOptions] = useState<Named[]>([]);
  useEffect(() => {
    if (q.trim().length < 2) return setOptions([]);
    const timer = window.setTimeout(() => {
      api
        .op<{ rows: Named[] }>('admin.merchants.list', { q: q.trim(), limit: 8, ...(market ? { market } : {}) })
        .then((r) => setOptions(r.rows.map((row) => ({ ref: row.ref, name: row.name }))))
        .catch(() => setOptions([]));
    }, 200);
    return () => window.clearTimeout(timer);
  }, [q, market]);

  if (value) {
    return (
      <label>
        {label}
        <span className="aff-inline">
          <input value={value.name} readOnly aria-label={label} />
          <button type="button" className="btn btn-ghost btn-small" disabled={disabled} onClick={() => onChange(null)} aria-label={`Clear ${label}`}>
            ×
          </button>
        </span>
      </label>
    );
  }
  return (
    <label style={{ position: 'relative' }}>
      {label}
      <input value={q} disabled={disabled} placeholder="Type to search…" onChange={(e) => setQ(e.target.value)} aria-label={label} />
      {options.length ? (
        <span className="chips" role="listbox" aria-label={`${label} matches`}>
          {options.map((o) => (
            <button
              key={o.ref}
              type="button"
              className="chip"
              role="option"
              aria-selected="false"
              onClick={() => {
                onChange(o);
                setQ('');
                setOptions([]);
              }}
            >
              {o.name}
            </button>
          ))}
        </span>
      ) : null}
    </label>
  );
}

export function SiteSelect({ sites, value, onChange, label = 'Site', allLabel }: { sites: Named[]; value: string; onChange: (ref: string) => void; label?: string; allLabel?: string }) {
  return (
    <label>
      {label}
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {allLabel !== undefined ? <option value="">{allLabel}</option> : null}
        {sites.map((s) => (
          <option key={s.ref} value={s.ref}>
            {s.name}
          </option>
        ))}
      </select>
    </label>
  );
}
